import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
} from "../../styledElements";
import { Button, Row, Col, Form, Input, Select, PageHeader, Radio, Switch, Collapse } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { GlobalSet } from "../../pageStyled";
import { addMachine } from "../../../Services/machineServices";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import { useNavigate } from "react-router";
import warning from "../../../Assets/Icons/warning.png";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import { paperMachineListDataForConfiguration } from "../../../Services/machineServices";
import { capital_letter } from "../../../Utils/helper/helper";
import {getUnitData} from '../../../Services/measurementService';
import { lengthUnit, weightUnit } from "../../../Utils/Constant/MeasurementUnitList";
import styled from "styled-components";
import { ModalPopup } from "../../../Components/Modal/modal";
import warningjob from "../../../Assets/Icons/warningjob.svg";
import crossIcon from "../../../Assets/Icons/wrong.svg"

const { Option } = Select;
const deckleWidthData = ["mm", "cm"];
const userStatusData = [
  { label: "Active", value: "active" },
  { label: "Disabled", value: "disabled" },
];
const orderTypeData = [
  { label: "Reel", value: "reel" },
  { label: "Sheet", value: "sheet" },
  { label: "Both", value: "both" },
];

const { TextArea } = Input;
const LabelContainer = styled.div`
  display:flex;
  justify-content:flex-start;
  gap:20px;
  &>p{
    font-weight: bold;
    color: rgba(50, 49, 48, 1);
    margin-right: 10px;
  }
  &>span {
    color:rgba(59, 58, 57, 1);
    font-size: 12px;
    margin-top: 2px;
    &>span{
      color: rgba(234, 101, 91, 1);
    }
  }
`

const AddNewMachine = (props) => {
  const [userStatus, setUserStatus] = useState(userStatusData[0].value);
  const [orderType, setOrderType] = useState(orderTypeData[2].value);
  const [value, setValue] = useState("mm");
  const [form] = Form.useForm();
  const [success, setSuccess] = useState(false);
  const [successMsg,setSuccessMsg] = useState("");
  const [error, setError] = useState(false);
  const [visible, setVisible] = useState(false);
  const [widthValidationError, setWidthValidationError] = useState(false);
  const [minWidthValidationErrorFor0, setMinWidthValidationErrorFor0] = useState(false);
  const [maxWidthValidationErrorFor0, setMaxWidthValidationErrorFor0] = useState(false);
  const [gsmValidationError, setGSMValidationError] = useState(false);
  const [minGSMValidationErrorFor0, setMinGSMValidationErrorFor0] = useState(false);
  const [maxGSMValidationErrorFor0, setMaxGSMValidationErrorFor0] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [machineNameErr, setMachineNameErr] = useState(false);
  const [machineList, setMachines] = useState([]);
  const navigate = useNavigate();
  const [unitData,setUnitData] = useState();
  const [isDecklewidthgsmwise,setDecklewidthgsmwise] = useState(false);
  const [activeKey,setActiveKey] = useState(['1']);
  const [gsmRangeErrors,setGSMRangeErrors] = useState([]);
  const [isGSMWiseWidthsError,setGSMWiseWidthsError] = useState(false)
  const [gsmError,setGSMError] = useState(false);
  const minDeckleWidth = useRef(0);
  const maxDeckleWidth = useRef(0);
  const {Panel} = Collapse


  const Label = ({ind,isActive,form}) =>{
    const values = form.getFieldValue(["gsmWiseWidths",ind])
    return (
      <LabelContainer>
        <p>{`GSM Range ${ind+1}`}</p>
        {isActive && <span>GSM: <span>{`${values?.min_gsm?values?.min_gsm:0} - ${values?.max_gsm?values?.max_gsm:0}`}</span></span>}
        {isActive && <span>Deckle width: <span>{`${values?.min_deckle_width?values?.min_deckle_width:0} - ${values?.max_deckle_width?values?.max_deckle_width:0} ${unitData?.units_management?.length?.default}`}</span></span>}
      </LabelContainer>
    )
  }

  const GSMWiseCards = ({field}) => {

    return (
      <div style={{backgroundColor:"rgba(250, 249, 248, 1)"}}>
        <Row style={{marginBottom:"5px"}} gutter={3}>
          <Col span={12}>
            <span style={{fontSize:"12px", color:"rgba(59, 58, 57, 1)"}} >GSM Range</span>
          </Col>
          <Col span={6}>
            <Form.Item
              {...field}
              name={[field.name,"min_gsm"]}
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
                {
                  pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                  message:
                    "Only numeric characters are allowed upto 3 decimal points",
                },  
                {
                  validator: (_,value)=>{
                    const max_gsm = form.getFieldValue(["gsmWiseWidths",field.name,"max_gsm"]);
                    console.log(form.getFieldValue("min_gsm"));
                    if(!form.getFieldValue("min_gsm") || !form.getFieldValue("max_gsm"))
                    {
                      return Promise.reject("GSM Range not defined!")
                    }
                    if(parseFloat(value)>parseFloat(max_gsm))
                      return Promise.reject("Min. GSM cannot be greater than Max. GSM!");
                    if(!form.getFieldValue("min_gsm") || parseFloat(value)<parseFloat(form.getFieldValue("min_gsm")))
                      return Promise.reject("Min. GSM cannot be less than "+form.getFieldValue("min_gsm"))
                    form.setFields([
                      {
                        name: ["gsmWiseWidths",field.name,"max_gsm"],
                        errors: [],
                      }
                    ])
                    return Promise.resolve();
                  }
                }      
              ]}
              normalize={(value) => {
                if (value === '' || value === null || value === undefined) return value;

                const num = parseFloat(value);
                return isNaN(num) ? value : num;
              }}
            >
              <Input placeholder="Min.GSM" disabled={!form.getFieldValue("min_gsm") && !form.getFieldValue("max_gsm") }/>
            </Form.Item>
          </Col>
          <Col span={6}>
              <Form.Item
              {...field}
              name={[field.name,"max_gsm"]}
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
                {
                  pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                  message:
                    "Only numeric characters are allowed upto 3 decimal points",
                },
                {
                  validator: (_,value)=>{
                    const min_gsm = form.getFieldValue(["gsmWiseWidths",field.name,"min_gsm"]);
                    if(!form.getFieldValue("min_gsm") || !form.getFieldValue("max_gsm"))
                    {
                      return Promise.reject("GSM Range not defined!")
                    }
                    if(parseFloat(value)<parseFloat(min_gsm))
                      return Promise.reject("Max. GSM cannot be less than Min. GSM!");
                    if(!form.getFieldValue("max_gsm") || parseFloat(value)>parseFloat(form.getFieldValue("max_gsm")))
                      return Promise.reject("Max. GSM cannot be greater than "+form.getFieldValue("max_gsm"))
                    form.setFields([
                      {
                        name: ["gsmWiseWidths",field.name,"min_gsm"],
                        errors: [],
                      }
                    ])
                    return Promise.resolve();
                  }
                }      
              ]}
              normalize={(value) => {
                if (value === '' || value === null || value === undefined) return value;

                const num = parseFloat(value);
                return isNaN(num) ? value : num;
              }}
            >
              <Input  placeholder="Max.GSM" disabled={!form.getFieldValue("min_gsm") && !form.getFieldValue("max_gsm") }/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={3}>
          <Col span={12}>
            <span style={{fontSize:"12px", color:"rgba(59, 58, 57, 1)"}}>{`Deckle Width (${unitData?.units_management?.length?.default})`}</span>
          </Col>
          <Col span={6}>
              <Form.Item
              {...field}
              name={[field.name,"min_deckle_width"]}
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
                {
                  pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                  message:
                    "Only numeric characters are allowed upto 3 decimal points",
                },     
                {
                  validator: (_,value)=>{
                    const max_width = form.getFieldValue(["gsmWiseWidths",field.name,"max_deckle_width"]);
                    if(parseFloat(value)>parseFloat(max_width))
                      return Promise.reject("Min. width cannot be greater than Max. width!");
                    form.setFields([
                      {
                        name: ["gsmWiseWidths",field.name,"max_deckle_width"],
                        errors: [],
                      }
                    ])
                    return Promise.resolve();
                  }
                }   
              ]}
              normalize={(value) => {
                if (value === '' || value === null || value === undefined) return value;

                const num = value.endsWith(".")?value:parseFloat(value);
                return isNaN(num) ? value : num;
              }}
            >
              <Input placeholder="Min.Width"/>
            </Form.Item>
          </Col>
          <Col span={6}>
              <Form.Item
              {...field}
              name={[field.name,"max_deckle_width"]}
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
                {
                  pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                  message:
                    "Only numeric characters are allowed upto 3 decimal points",
                },  
                {
                  validator: (_,value)=>{
                    const min_width = form.getFieldValue(["gsmWiseWidths",field.name,"min_deckle_width"]);
                    if(parseFloat(value)<parseFloat(min_width))
                      return Promise.reject("Max. width cannot be less than Min. width!");
                    form.setFields([
                      {
                        name: ["gsmWiseWidths",field.name,"min_deckle_width"],
                        errors: [],
                      }
                    ])
                    return Promise.resolve();
                  }
                }      
              ]}
              normalize={(value) => {
                if (value === '' || value === null || value === undefined) return value;

                const num = value.endsWith('.')?value:parseFloat(value);
                return isNaN(num) ? value : num;
              }}
            >
              <Input placeholder="Max Width"/>
            </Form.Item>
          </Col>
        </Row>
      </div>
    )
  }

  const Delete = ({field,remove}) => {
    return <span onClick={()=>remove(field.name)}><Iconmoon icon="delete" color={"rgba(234, 101, 91, 1)"} size={12}/></span>
  }

  const routeBack = (action, response) => {
    navigate("../machine-records/", {
      state: { action: action, response: response },
    });
  };

  const modalShow = () => {
    setVisible(true);
  };

  const modalCancel = () => {
    setVisible(false);
  };

  const modalConfirm = () => {
    setVisible(false);
    routeBack();
  };

  const handleStatusChange = (e) => {
    setUserStatus(e.target.value);
  };

  const handleOrderTypeChange = (e) => {
    setOrderType(e.target.value);
  };

  const handleSelect = (e) => {
    setValue(e);
  };

  const setTrimLoss = () => {
    if (form.getFieldValue("max_width") && form.getFieldValue("min_width")) {
      // setEffectiveDeckle();
      const max_waste =
        ((form.getFieldValue("max_width") - form.getFieldValue("min_width")) /
          form.getFieldValue("max_width")) *
        100;
      form.setFieldsValue({
        max_waste: max_waste.toFixed(2),
      });
    }
  };

  // const setEffectiveDeckle = () => {
  //   if (
  //     form.getFieldValue("max_width") &&
  //     form.getFieldValue("left_trim") &&
  //     form.getFieldValue("right_trim")
  //   ) {
  //     if (form.getFieldValue("max_width") -
  //       form.getFieldValue("left_trim") -
  //       form.getFieldValue("right_trim") < 0) {
  //       form.setFieldsValue({
  //         max_width: "",
  //         left_trim: "",
  //         right_trim: "",
  //         deckle_length: ""
  //       })
  //     } else {
  //       form.setFieldsValue({
  //         deckle_length:
  //           form.getFieldValue("max_width") -
  //           form.getFieldValue("left_trim") -
  //           form.getFieldValue("right_trim"),
  //       });
  //     }

  //   }
  // };

  const addMachineHandler = () => {
    form.submit();
  };

  const onFinish = async (values) => {
    if(isDecklewidthgsmwise)
      await handleSave(false);
    console.log(values,isDecklewidthgsmwise,minDeckleWidth,maxDeckleWidth,"");
    let machineName = capital_letter(values.machine_name);
    console.log(machineName);
    const body = {
      //code:values.machine_code,
      // name: values.machine_name.charAt(0).toUpperCase() + values.machine_name.slice(1),
      name: machineName,
      minimum_gsm: values.min_gsm,
      maximum_gsm: values.max_gsm,
      gsm_wise_deckle_enabled: isDecklewidthgsmwise,
      minimum_width: (isDecklewidthgsmwise)?minDeckleWidth.current:values.min_width,
      maximum_width: (isDecklewidthgsmwise)?maxDeckleWidth.current:values.max_width,
      ...isDecklewidthgsmwise?{gsm_wise_deckle_configs: values.gsmWiseWidths}:{},
      production_capacity: values.prod_capacity,
      order_type: values.order_type,
      maximum_cutters: values.max_cutters,
      maximum_waste: values.max_waste,
      status: values.status,
      remarks: values.remarks,
      units : {
        minimum_width : (isDecklewidthgsmwise)?unitData?.units_management?.length.default:values.length_unit,
        maximum_width : (isDecklewidthgsmwise)?unitData?.units_management?.length.default:values.length_unit,
        min_deckle_width : unitData?.units_management?.length.default,
        max_deckle_width : unitData?.units_management?.length.default,
        production_capacity : values.production_unit
      }
    };
    try {
      const editPoResponse = await addMachine(body);
      const res = {
        error: editPoResponse.error,
        data: editPoResponse.data,
        msg: editPoResponse.msg,
      };
      routeBack("add", res);
      // if (!editPoResponse.error) {
      //   setSuccess(true);
      //   setTimeout(() => {
      //     setSuccess(false);
      //   }, 2000);
      // }
    } catch (error) {
      
      setError(true);
      // setErrorMsg(error.response.data.msg.name);
      // setTimeout(() => {
      //   setError(false);
      //   setErrorMsg("");
      // }, 2000);

      if(error?.response?.status == 500){
        setErrorMsg("Something went wrong. Please try again");
      } else{
        setErrorMsg(error?.response?.data?.msg);
      }

      setTimeout(() => {
        setError(false);
        setErrorMsg("");
      }, 2000);
    }
  };

  const validateMinMaxWidth = () => {
    if (
      form.getFieldValue("min_width") &&
      form.getFieldValue("max_width") && 
      (parseFloat(form.getFieldValue("max_width")) < parseFloat(form.getFieldValue("min_width")))) {
      setWidthValidationError(true);
    } else if(((parseFloat(form.getFieldValue("min_width"))) == 0)){
      setMinWidthValidationErrorFor0(true);
    } else if(((parseFloat(form.getFieldValue("max_width"))) == 0)){
      setMaxWidthValidationErrorFor0(true);
    } else {
      setMaxWidthValidationErrorFor0(false);
      setMinWidthValidationErrorFor0(false);
      setWidthValidationError(false);
    }
  };

  const validateMinMaxGSM = () => {
    if(isDecklewidthgsmwise)
    {
      const gsmWiseWidths = form.getFieldValue('gsmWiseWidths');
      let max_gsm = Number.MIN_SAFE_INTEGER;
      let min_gsm = Number.MAX_SAFE_INTEGER;

      gsmWiseWidths.forEach((item) => {
        max_gsm = Math.max(item?.max_gsm,max_gsm);
        min_gsm = Math.min(item?.min_gsm,min_gsm);
      })

      if(form.getFieldValue("min_gsm")>min_gsm)
      {
        setGSMError(true);
      }
      if(form.getFieldValue("max_gsm")<max_gsm)
      {
        setGSMError(true);
      }
    }

    if (
      form.getFieldValue("min_gsm") &&
      form.getFieldValue("max_gsm") && 
      (parseFloat(form.getFieldValue("max_gsm")) < parseFloat(form.getFieldValue("min_gsm")))) {
      setGSMValidationError(true);
    } else if(((parseFloat(form.getFieldValue("min_gsm"))) == 0)){
      setMinGSMValidationErrorFor0(true);
    } else if(((parseFloat(form.getFieldValue("max_gsm"))) == 0)){
      setMaxGSMValidationErrorFor0(true);
    } else {   
      setMaxGSMValidationErrorFor0(false);
      setMinGSMValidationErrorFor0(false);
      setGSMValidationError(false);
      setGSMError(false);
    }
  };

  const onMachineNameChange = (event) => {
    console.log(event)
    setMachineNameErr(false);
    if(machineList.length > 0){
      machineList?.forEach((machine) => {
        if(machine.name.toLowerCase() === event.target.value.toLowerCase()){
          setMachineNameErr(true);
        }
      });
    }
  };

  const onFinishFailed = (e) => {
    if(isDecklewidthgsmwise)
      handleSave(true);
  }

  const handleSave = async(withMsg=true) => {
    try{
      const values = form.getFieldValue("gsmWiseWidths");
      await form.validateFields(
        values.flatMap((_,index)=>[
          ["gsmWiseWidths",index,"min_gsm"],
          ["gsmWiseWidths",index,"max_gsm"],
          ["gsmWiseWidths",index,"min_deckle_width"],
          ["gsmWiseWidths",index,"max_deckle_width"]
        ])
      )

      const upper = parseFloat(form.getFieldValue("max_gsm"));
      const lower = parseFloat(form.getFieldValue("min_gsm"))
      const size = upper-lower+1;
      let errors = [];
      let rangeArray = new Array(size);
      let absoluteMinDeckleWidth = Number.MAX_SAFE_INTEGER;
      let absoluteMaxDeckleWidth = Number.MIN_SAFE_INTEGER;
      rangeArray.fill(0);
      rangeArray[0] = 1;
      rangeArray[size-1] = -1;
      const gsmWiseWidths = form.getFieldValue("gsmWiseWidths");

      gsmWiseWidths.forEach((item)=>{
        rangeArray[item.min_gsm - lower] -= 1;
        rangeArray[item.max_gsm - lower] += 1;

        absoluteMinDeckleWidth = Math.min(absoluteMinDeckleWidth,item.min_deckle_width)
        absoluteMaxDeckleWidth = Math.max(absoluteMaxDeckleWidth,item.max_deckle_width)        
      });

      minDeckleWidth.current = absoluteMinDeckleWidth;
      maxDeckleWidth.current = absoluteMaxDeckleWidth;

      let minus = [] ;
      let plus = [];
      for(let i=0;i<size;i++)
      {
        if(rangeArray[i]>0)
        {
          if(minus.length!=0)
          {
            const elem = minus.pop();
            errors.push(`Overlapping GSM range (${lower+elem}-${lower+i})`);
            rangeArray[i]-=1;     
          }
          for(let j=1;j<=rangeArray[i];j++)
          {
            plus.push(i);
          }
        }
        else if(rangeArray[i]<0)
        {
          if(plus.length!=0)
          {
            const elem = plus.pop();
            errors.push(`No deckle width range defined for GSM range (${lower+elem}-${lower+i})`)
            rangeArray[i]+=1;
          }
          for(let j=1;j<=rangeArray[i]*(-1);j++)
          {
            minus.push(i);
          }
        }
      }
      console.log(errors);
      setGSMRangeErrors(errors);
      if(errors.length > 0)
        setGSMWiseWidthsError(true);
      else if(withMsg)
      {
        setActiveKey([]);
        setSuccess(true);
        setSuccessMsg("GSM wise Deckle widths saved successfully !")
        setTimeout(()=>{
          setSuccess(false)
        },2000)
        
      }
      return true;
    }
    catch(e)
    {
      console.log(e);
      setError(true);
      setErrorMsg("GSM wise widths not filled!")
      setTimeout(()=>{
        setError(false)
      },2000);
      throw e;
    }
  }

  useEffect(async () => {
    let params = "";
    const records = await paperMachineListDataForConfiguration(params);
    if(records){
      setMachines(records);
    }
   const response= await getUnitData();
   setUnitData(response.data);
        
  },[]);

  return unitData ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          // onBack={() => window.history.back()}
          title="Add a new machine"
          extra={[
            <Button key="3" className="textTypeBtn" onClick={modalShow}>
              Cancel changes
            </Button>,
            <Button
              key="2"
              className="themeBtn"
              onClick={() => addMachineHandler()}
            >
              <Iconmoon icon="addcircle" size={14} color="#ffffff" />
              Add Machine
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>
                      The General detail of Paper Machine will be used in deckle
                      mtching records and reports
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  {/* <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Machine Code</label>
                        <p>This is an auto generated code</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="machine_code"
                          //rules={[{ required: true }]}
                          className=""
                        >
                          <Input
                            placeholder="Machine code"
                            disabled
                            //defaultValue="HW19092021"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row> */}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Machine Name</label>
                        <p>The machine will be identified using this name</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="machine_name"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              max: 50,
                              message:
                                "Name can have a maximum of 50 characters",
                            },
                            {
                              validator(_, value) {
                                if(machineNameErr){
                                return Promise.reject("Machine name must be unique");
                                } else{
                                  return Promise.resolve();
                                }
                              },
                            },
                          ]}
                          className=""
                        >
                          <Input
                            placeholder="Enter name of the machine"
                            onChange = {onMachineNameChange}
                            style={{ textTransform: "capitalize" }}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Machine Specifications</h2>
                    <p>
                      The machine specification will be used to decide what can
                      be produced on this paper machine
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>GSM Range</label>
                        <p>The machine can produce paper of this GSM range</p>
                      </div>
                    </Col>
                    <Col span={12} >
                      <Row className="centerAlign">
                      <Col span={24} className="d-flex">
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          name="min_gsm"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                              message:
                                "Only numeric characters are allowed upto 3 decimal points",
                            },
                          ]}
                          className=""
                          normalize={(value) => {
                            if (value === '' || value === null || value === undefined) return value;

                            const num = parseFloat(value);
                            return isNaN(num) ? value : num;
                          }}
                        >
                          <Input placeholder="Enter min GSM" 
                          className={
                            gsmValidationError || gsmError ? "showErrorBorder" : ""
                          }
                          onChange={(e) => {
                            validateMinMaxGSM();
                          }}/>
                        </Form.Item>
                      </div>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          name="max_gsm"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                              message:
                                "Only numeric characters are allowed upto 3 decimal points",
                            },
                          ]}
                          className=""
                          normalize={(value) => {
                            if (value === '' || value === null || value === undefined) return value;

                            const num = parseFloat(value);
                            return isNaN(num) ? value : num;
                          }}
                        >
                          <Input placeholder="Enter max GSM" 
                          className={
                            gsmValidationError || gsmError ? "showErrorBorder" : ""
                          }
                          onChange={(e) => {
                            validateMinMaxGSM();
                          }}/>
                        </Form.Item>
                      </div>
                      </Col>
                      {gsmValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max GSM cannot be less than Min GSM
                          </span>
                        ) : null
                      }
                      {maxGSMValidationErrorFor0 ? (
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              Max GSM cannot be 0
                            </span>
                          ) : null 
                      }
                      {minGSMValidationErrorFor0 ? (
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              Min GSM cannot be 0
                            </span>
                          ) : null 
                      }
                      {gsmError ? 
                        <span
                          className="errorText"
                          style={{ color: "#ea4e2c" }}
                        >
                          GSM Range overflows specified GSM
                        </span>:null
                      }
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>GSM wise deckle width</label>
                        <p>
                          Add GSM wise deckle width
                        </p>
                      </div>
                    </Col>
                    <Col span={12} >
                      <Form.Item
                        style={{marginLeft:"auto",marginRight:"0px"}}
                        name="isDeckleWidthGSMwise"
                        valuePropName="checked"
                      >
                        <GlobalSet>
                        <Switch
                          checked={isDecklewidthgsmwise}
                          onChange={(checked)=>setDecklewidthgsmwise(checked)}
                          className="switch-new"
                        />
                        </GlobalSet>
                      </Form.Item>
                    </Col>
                  </Row>
                  {(isDecklewidthgsmwise)
                  ?<Row className="centerAlign">
                    <Col span={24}>
                      <div className="boxFieldTitle" style={{width:"100%"}}>
                        <label>GSM wise deckle width</label>
                        <Form.List
                          name="gsmWiseWidths"
                        >
                          {(fields,{add,remove})=>(
                            <>
                              <Collapse
                                activeKey={activeKey}
                                onChange={(e)=>{setActiveKey(e)}}
                                expandIconPosition={"right"}
                                bordered={false}
                              >
                                {fields.map((field,index)=>{
                                  let id = form.getFieldValue(["gsmWiseWidths",field.name,"id"])
                                  return (
                                  <Panel
                                    key={id}
                                    style={{
                                      backgroundColor:"rgba(250, 249, 248, 1)",
                                      border:"1px solid rgba(225, 223, 221, 1)",
                                      borderRadius:"6px", marginBlock:"10px",
                                      overflow:"hidden"
                                    }}
                                      header={<Label ind={index} isActive={!activeKey.includes(id)} form={form}/>}
                                    extra={<Delete field={field} remove={remove}/>}
                                  >
                                    <GSMWiseCards field={field}/>
                                  </Panel>
                                )}
                                )}
                              </Collapse>
                              <div style={{display:"flex",justifyContent:"space-between",marginBlock:"10px",marginInline:"-12px"}}>
                                <Button 
                                  onClick={async() => {
                                    let id = Date.now().toString();
                                    add({
                                      id: id,
                                      min_gsm: undefined,
                                      max_gsm: undefined,
                                      min_deckle_width: undefined,
                                      max_deckle_width: undefined,
                                    })
                                    setActiveKey([id]);
                                  }} 
                                  className="themeBtn noBg"
                                  >
                                  <Iconmoon icon="addcircle" size={14} color="rgba(234, 101, 91, 1)" /> Add GSM Range
                                </Button>
                                <Button onClick={() => handleSave()} className="themeBtn">
                                  <Iconmoon icon="addcircle" size={14} color="#ffffff"/> Save
                                </Button>
                              </div>
                            </>
                          )
                          }
                        </Form.List>
                      </div>
                    </Col>
                  </Row>
                  :<Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Deckle Width Range</label>
                        <p>
                          The minimum and maximum deckle width of this machine
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          name="min_width"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^\d+(\.\d{0,2})?$/,
                              message:
                                "Upto 2 decimal point values is accepted",
                            },
                          ]}
                          className=""
                          onChange={setTrimLoss}
                          normalize={(value) => {
                            if (value === '' || value === null || value === undefined) return value;

                            const num = value.endsWith(".")?value:parseFloat(value);;
                            return isNaN(num) ? value : num;
                          }}
                        >
                          <Input placeholder="Min width"
                           className={
                            widthValidationError ? "showErrorBorder" : ""
                          }
                          onChange={(e) => {
                            validateMinMaxWidth();
                          }}
                          />
                        </Form.Item>
                      </div>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          name="max_width"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^\d+(\.\d{0,2})?$/,
                              message:
                                "Upto 2 decimal point values is accepted",
                            },
                          ]}
                          className=""
                          onChange={setTrimLoss}
                          normalize={(value) => {
                            if (value === '' || value === null || value === undefined) return value;

                            const num = value.endsWith(".")?value:parseFloat(value);;
                            return isNaN(num) ? value : num;
                          }}
                        >
                          <Input placeholder="Max width" 
                          className={
                            widthValidationError ? "showErrorBorder" : ""
                          }
                          onChange={(e) => {
                            validateMinMaxWidth();
                          }}
                          />
                        </Form.Item>
                      </div>
                      <div
                        className="boxFormType unitSelect"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item name="length_unit" initialValue={unitData.units_management.length.default}>
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            onChange={handleSelect}
                          >
                            {unitData.units_management.length.data.map((deckleWidth) => (
                              <Option key={deckleWidth}>{lengthUnit[deckleWidth].displayName}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                      </Col>
                      {widthValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max width cannot be less than Min width
                          </span>
                        ) : null
                      }
                      {maxWidthValidationErrorFor0 ? (
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              Max width cannot be 0
                            </span>
                          ) : null 
                      }
                      {minWidthValidationErrorFor0 ? (
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              Min width cannot be 0
                            </span>
                          ) : null 
                      }
                      </Row>
                    </Col>
                  </Row>}
                  {/* <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Default Edge Trim</label>
                        <p>
                          Default left and right edge trim on the paper machine
                        </p>
                      </div>
                    </Col>
                    <Col span={12} className="d-flex threeFields">
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          name="left_trim"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^\d+(\.\d{0,2})?$/,
                              message: "Invalid format",
                            },
                          ]}
                          className=""
                          onChange={setEffectiveDeckle}
                        >
                          <Input placeholder="Left trim" />
                        </Form.Item>
                      </div>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item
                          name="right_trim"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^\d+(\.\d{0,2})?$/,
                              message: "Invalid format",
                            },
                          ]}
                          className=""
                          onChange={setEffectiveDeckle}
                        >
                          <Input placeholder="Right trim" />
                        </Form.Item>
                      </div>
                      <div className="boxFormType unitSelect">
                        <Form.Item
                          name="length_unit"
                          rules={[{ required: true }]}
                          className=""
                        >
                          <Input placeholder="" disabled value={value} />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row> */}
                  {/* <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Effective Deckle Length</label>
                        <p>
                          Effective deckle length to match orders after
                          adjusting for edge trim
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="deckle_length"
                          //rules={[{}]}
                          className=""
                        >
                          <Input placeholder="" disabled />
                        </Form.Item>
                        <span className="nonEditable">{value}</span>
                      </div>
                    </Col>
                  </Row> */}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Effective Production Capacity</label>
                        <p>
                          Production capacity after adjusting for machine
                          efficiency
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                    <Row className="centerAlign">
                      <Col span={24} className="d-flex">
                      <div className="boxFormType">
                        <Form.Item
                          name="prod_capacity"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^\d+(\.\d{1,3})?$|^\.\d{1,3}$/,
                              message: "Only decimal characters upto 3 decimal places are allowed",
                            },
                          ]}
                          className=""
                          normalize={(value) => {
                            if (value === '' || value === null || value === undefined) return value;

                            const num = value.endsWith(".")?value:parseFloat(value);;
                            return isNaN(num) ? value : num;
                          }}
                        >
                          <Input placeholder="Enter production capacity" />
                        </Form.Item>
                      </div>
                      <div
                        className="boxFormType unitSelect"
                        style={{ marginBottom: "0" }}
                      >
                        <Form.Item name="production_unit" initialValue={unitData.units_management.weight.default}>
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                          >
                            {unitData.units_management.weight.data.map((deckleWidth) => (
                              <Option key={ deckleWidth}>{weightUnit[deckleWidth].displayName}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                      </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Order Types</label>
                        <p>The machine can only produce selected order types</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio threeSwitch"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="order_type"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue="both"
                        >
                          <Radio.Group
                            options={orderTypeData}
                            onChange={handleOrderTypeChange}
                            value={orderType}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  {/* <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Maximum cutters</label>
                        <p>The maximum number of cutters which can be placed</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="max_cutters"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^[0-9]*$/,
                              message: "Invalid format",
                            },
                            {
                              max: 8,
                              message: "Invalid format",
                            },
                          ]}
                          className=""
                        >
                          <Input placeholder="Enter number of cutters" />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row> */}
                  {/* <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Maximum Allowed Trim Loss</label>
                        <p>The maximum allowed trim loss in percentage</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item name="max_waste" rules={[{}]} className="">
                          <Input placeholder="" disabled />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row> */}
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Other Information</h2>
                    <p>All Other information related to this paper machine</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Status</label>
                        <p>
                          The machine can only be used if it is set to active
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="status"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue="active"
                        >
                          <Radio.Group
                            options={userStatusData}
                            onChange={handleStatusChange}
                            value={userStatus}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Remarks <span>(Optional)</span>
                        </label>
                        <p>
                          Any other information related to this paper machine
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Form.Item
                            name="remarks"
                            // rules={[{ required: true }]}
                            className=""
                          >
                            <TextArea
                              maxLength={100}
                              style={{ height: 90 }}
                              placeholder="Enter remarks"
                            />
                          </Form.Item>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>

      <ConfirmationModal
        visible={visible}
        icon={warning}
        cancelAction={modalCancel}
        confirmAction={modalConfirm}
      >
        <span>Are you sure?</span>
        <p>
          You have pending changes on this page, are you sure you want to leave?
        </p>
      </ConfirmationModal>

      <ModalPopup
        visible={isGSMWiseWidthsError}
      >
        <div className="top-close-icon" onClick={()=>{setGSMWiseWidthsError(false)}}>
          <img width="20px" src={crossIcon} alt="Close"/>
        </div>
        <div className="Popup-img">
          <img src={warningjob} alt="Warning" height={36} />
        </div>
        <div className="Popup-content">
          <span>Fix Below Errors to Save</span>
          {gsmRangeErrors.map((error,index)=>(<p style={{...index!=gsmRangeErrors.length-1?{paddingBottom:"0px",marginBottom:"0px"}:{}}}>
            {index+1}. {error}
          </p>))}
        </div>
        <div className="ant-modal-footer-section">
          <Button
            className="themeBtn"
            onClick={() => setGSMWiseWidthsError(false)}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Okay
          </Button>
        </div>
      </ModalPopup>

      {success && (
        <AlertContainer
          setClose={setSuccess}
          color="green toaster"
          icon={alertGreen}
          msg={successMsg}
          closeIcon={true}
        />
      )}

      {error && (
        <AlertContainer
          setClose={setError}
          color="red toaster"
          icon={alertRed}
          msg={errorMsg}
          closeIcon={true}
        />
      )}
    </RightLayoutContainer>
  ): null;
};

export default AddNewMachine;
